/**
 * @generated SignedSource<<ec07190fb98e0f971c23bf5f1ea3300a>>
 * @relayHash ca950652c375632e8e3242fc2e8e313a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContributorsMacroParametersModel = {
  contentType?: string | null;
  include?: string | null;
  label?: string | null;
  labels?: string | null;
  limit?: number | null;
  mode?: string | null;
  name?: string | null;
  noneFoundMessage?: string | null;
  order?: string | null;
  page?: string | null;
  publishDate?: string | null;
  reverse?: boolean | null;
  scope?: string | null;
  showAnonymous?: boolean | null;
  showCount?: boolean | null;
  showLastTime?: boolean | null;
  space?: string | null;
  spaces?: string | null;
};
export type useContributorsDataQuery$variables = {
  contentId?: string | null;
  contentStatus?: ReadonlyArray<string | null> | null;
  contributorsMacroParameters?: ConfluenceContributorsMacroParametersModel | null;
};
export type useContributorsDataQuery$data = {
  readonly singleContent: {
    readonly contributorsMacro: {
      readonly authorRankingList: ReadonlyArray<{
        readonly comments: number | null;
        readonly edits: number | null;
        readonly fullNameString: string | null;
        readonly idString: string | null;
        readonly labels: number | null;
        readonly lastCommentTime: AGG$Long | null;
        readonly lastEditTime: AGG$Long | null;
        readonly lastLabelTime: AGG$Long | null;
        readonly watches: number | null;
      } | null> | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type useContributorsDataQuery = {
  response: useContributorsDataQuery$data;
  variables: useContributorsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStatus"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributorsMacroParameters"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "contentStatus"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "contributorsMacroParameters",
            "variableName": "contributorsMacroParameters"
          }
        ],
        "concreteType": "ConfluenceContributorsRankings",
        "kind": "LinkedField",
        "name": "contributorsMacro",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceAuthorRanking",
            "kind": "LinkedField",
            "name": "authorRankingList",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "idString"
              },
              {
                "kind": "ScalarField",
                "name": "fullNameString"
              },
              {
                "kind": "ScalarField",
                "name": "edits"
              },
              {
                "kind": "ScalarField",
                "name": "comments"
              },
              {
                "kind": "ScalarField",
                "name": "labels"
              },
              {
                "kind": "ScalarField",
                "name": "watches"
              },
              {
                "kind": "ScalarField",
                "name": "lastEditTime"
              },
              {
                "kind": "ScalarField",
                "name": "lastCommentTime"
              },
              {
                "kind": "ScalarField",
                "name": "lastLabelTime"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContributorsDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContributorsDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ca950652c375632e8e3242fc2e8e313a",
    "id": "d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3",
    "metadata": {},
    "name": "useContributorsDataQuery",
    "operationKind": "query",
    "text": "query useContributorsDataQuery($contentId:ID,$contentStatus:[String],$contributorsMacroParameters:ConfluenceContributorsMacroParametersModel){singleContent(id:$contentId,status:$contentStatus){id,contributorsMacro(contributorsMacroParameters:$contributorsMacroParameters){authorRankingList{idString,fullNameString,edits,comments,labels,watches,lastEditTime,lastCommentTime,lastLabelTime}}}}"
  }
};
})();

(node as any).hash = "2b1ea1963eb971919228dd0de7168930";

export default node;
